export function IconChild() {
    return (
        <svg width="8" height="7" viewBox="0 0 8 7" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM3 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM6.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" fill="#FFC738"/>
        </svg>
    );
}
